
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getVentilation } from "../../store/ventilationPage/VentilitaionPageFetch";
import useOrderValidate from "./orderValidate";
import AttachSvg from "../../assets/SVG/AttachSvg";
import PageSeo from "../../components/PageSeo";
import style from "./style.module.css";
import lang from "lang/lang";
import langData from "lang/data";
import axios from "axios";

const VentilationForm = ({ openModal, setOpenModal }) => {

    const dispatch = useDispatch();
    const { currentLanguage } = useSelector(({main}) => main);
    const { ventilationInfo } = useSelector((state) => state.ventilationPageSlice);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [files, setFiles] = useState([]);

    console.log(ventilationInfo)

    useEffect(() => {
        dispatch(getVentilation());
    }, [dispatch]);

    const {
        validation,
        personInfo,
        errorText,
        setPersonInfo,
        setErrorText
    } = useOrderValidate();

    const handleChange = (e) => {
        setPersonInfo({...personInfo, [e.target.name]: e.target.value});
        setErrorText({...errorText, [e.target.name]: ""});
    };

    const handleChangeFile = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setFiles(prevState => [
            ...prevState,
            ...selectedFiles,
        ]);
        e.target.value = '';
    }

    const postData = async () => {
        setLoading(true);
        try {
            const _token = document.querySelector('meta[name="_token"]').content;
            let formData = new FormData();
            formData.append("login", "VlvShopA");
            formData.append("password", "oL0rG6vQ6k");
            formData.append("token", "quHRhfW9R7SbNFUCEBEBmzCRbIa5Z3");
            formData.append("name", personInfo.name);
            formData.append('surname', personInfo.surname);
            formData.append("email", personInfo.email);
            formData.append("phone", personInfo.phone);
            formData.append("address", personInfo.address);
            formData.append('projectName', personInfo.projectName);
            formData.append('messageText', personInfo.messageText);
            if (files.length > 0) {
                files.forEach((file, index) => {
                    formData.append(`file_${index}`, file);
                })
            }
            for (var pair of formData.entries()) {
                console.log(pair[0]+ ', ' + pair[1]);
            }
            const response = await axios.post(
                process.env.REACT_APP_SERVER_URL + "api/air-conditioning-order/send",
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-Token": _token,
                    }
                }
            );
            if (response) {
                setSuccess(true);
            }
        }
        catch (error) {
            setError(true);
        }
        finally {
            setLoading(false);
        }
    };

    const handleClick = async (e) => {
        e.preventDefault();
        if (validation()) {
            await postData();
        }
    };

    const closeModal = () => {
        setPersonInfo({
            name: '',
            surname:'',
            email:'',
            phone:'',
            projectName:'',
            address: '',
            messageText:''
        })
        setErrorText({
            name: '',
            email: '',
            phone: '',
            projectName:'',
            address: '',
        })
        setSuccess(false);
        setError(false);
        setOpenModal(false);
    }

    return (
        <>
            <PageSeo pageKey="ventilation" />
        <div className={style.container}>
            <div className={style.bannerConatiner}>
                <img
                    src={ process.env.REACT_APP_STORAGE_URL + ventilationInfo?.setting?.banner}
                    alt = { 'banner' }
                />
            </div>
            <form className = {style.order_form} onSubmit = {postData}>
                <h1>{lang[currentLanguage].order}</h1>
                <div className={style.add_personal_inputs}>
                    <div className={style.add_personal_inputs}>
                        <input
                            type="text"
                            value={personInfo.name}
                            name={"name"}
                            onChange={handleChange}
                            className={` ${errorText.name && style.inputError}`}
                            placeholder={lang[currentLanguage].name + " *"}
                        />
                    </div>
                    <div className={style.order_inputs_name}>
                        <input
                            type="text"
                            name={"surname"}
                            value={personInfo.lastName}
                            onChange={handleChange}
                            placeholder={lang[currentLanguage].last_name}
                        />
                    </div>
                </div>
                <div className={style.add_personal_inputs}>
                    <input
                        type = "text"
                        name = {"email"}
                        value = {personInfo.email}
                        onChange = {handleChange}
                        className ={ `${errorText.email && style.inputError}`}
                        placeholder = {lang[currentLanguage].email + " *"}
                    />
                </div>
                <div className={style.add_personal_inputs}>
                    <input
                        type = "number"
                        value = {personInfo.phone}
                        name = {"phone"}
                        onChange = {handleChange}
                        className = {`${errorText.phone && style.inputError}`}
                        placeholder = {lang[currentLanguage].phone + " *"}
                    />
                </div>
                <div className={style.add_personal_inputs}>
                    <input
                        type="text"
                        value={personInfo.projectName}
                        name={"projectName"}
                        onChange={handleChange}
                        className={` ${errorText.projectName && style.inputError}`}
                        placeholder={langData.projectName[currentLanguage] + " *"}
                    />
                </div>
                <div className={style.add_personal_inputs}>
                    <input
                        type = "text"
                        value = {personInfo.address}
                        name = {"address"}
                        onChange = {handleChange}
                        className = {`${errorText.address && style.inputError}`}
                        placeholder = {lang[currentLanguage].address + " *"}
                    />
                </div>
                <div className={style.add_files_data}>
                    <input
                        type="file"
                        multiple={true}
                        onChange={handleChangeFile}
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    />
                    <span className={style.attachFileContent}>
                        {/*<img*/}
                        {/*    src = { attachFile }*/}
                        {/*    alt = { 'attach File Icon' }*/}
                        {/*/>*/}
                        <AttachSvg
                            style={{
                                width: 20,
                                height: 20,
                            }}
                        />
                        <span>
                            {
                                files.length > 0 ?
                                    `${files.length} ${langData.file[currentLanguage]}`
                                    :
                                langData.attachFiles[currentLanguage]
                            }
                        </span>
                    </span>
                </div>
                <div className={style.add_personal_inputs}>
                    <textarea
                        value={personInfo.messageText}
                        onChange={handleChange}
                        name="messageText"
                        className={style.textarea_comment_order}
                        cols="30"
                        rows="5"
                        placeholder={lang[currentLanguage].comment_order}
                    />
                </div>
                {
                    error &&
                        <span
                            style = {{
                                color: "red",
                                fontSize: "0.8rem",
                                textAlign: 'center'
                            }}
                        >
                            {lang[currentLanguage].error_message}
                        </span>
                }
                {
                    success &&
                        <span
                            style = {{
                                color: "green",
                                fontSize: "0.8rem",
                                textAlign: 'center'
                            }}
                        >
                            {lang[currentLanguage].approved_successfully}
                        </span>
                }
                <button
                    onClick = { handleClick }
                    className = { style.order_submit }
                    type="submit"
                    disabled={loading}
                    style={{
                        opacity: loading ? 0.3 : 1 ,
                    }}
                >
                    {lang[currentLanguage].order_state + " *"}
                </button>
            </form>
            <p
                style={{
                    width: "100%",
                    textAlign: "center"
                }}
            >
                { ventilationInfo?.setting?.['text_' + currentLanguage] }
            </p>
        </div>
        </>
    );
};

export default VentilationForm;
